/* NP custom 2026-10-21: show the hovered (or focused) swatch's colour name beside the tile swatches; restore the current colour on leave. Delegated so it works on grids loaded by AJAX. */
(function () {
  function labelFor(item) {
    var row = item.closest('.np-tile-swatches-row');
    return row ? row.querySelector('.np-tile-swatches__label') : null;
  }
  function setLabel(label, text) {
    /* Change the existing text node in place. Replacing nodes (textContent) counts as a grid change and wakes every tile's MutationObserver on each hover. */
    var node = label.firstChild;
    if (node && node.nodeType === 3) { node.nodeValue = text; return; }
    label.textContent = text;
  }
  function show(e) {
    var item = e.target.closest && e.target.closest('.np-tile-swatches__item');
    if (!item) return;
    var label = labelFor(item);
    if (label) setLabel(label, item.getAttribute('data-colour') || label.getAttribute('data-default'));
  }
  function restore(e) {
    var list = e.target.closest && e.target.closest('.np-tile-swatches');
    if (!list || (e.relatedTarget && list.contains(e.relatedTarget))) return;
    var label = labelFor(list);
    if (label) setLabel(label, label.getAttribute('data-default'));
  }
  document.addEventListener('mouseover', show);
  document.addEventListener('focusin', show);
  document.addEventListener('mouseout', restore);
  document.addEventListener('focusout', restore);
})();
